import { InjectedConnector } from '@web3-react/injected-connector'
import config from '../../runtime/config'

export const injectionConnector = new InjectedConnector({ supportedChainIds: config.app.supportedChainIds })
